import { styled } from '@mui/system'

const PhotoLabel = styled('div', {
  shouldForwardProp: (prop) => prop !== 'withPhotoLabelToday',
})<{
  withPhotoLabelToday?: boolean
}>(({ theme, withPhotoLabelToday }) => ({
  position: 'absolute',
  height: '48px',
  width: '100%',
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#1e2127',
  '& p, svg': {
    color: '#fff',
  },
  ...(withPhotoLabelToday && {
    backgroundColor: theme.palette.primary.main,
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 0, 2),
  }),
}))

export default PhotoLabel
